import { render, staticRenderFns } from "./TongQuanHopDong.vue?vue&type=template&id=6d155222"
import script from "./TongQuanHopDong.vue?vue&type=script&lang=js"
export * from "./TongQuanHopDong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports